// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AIDocumentService {
   detailConfig: any
   docService: any
   isAIDocument: any
   translationService: any
   constructor(docService: any, translationService: any) {
      this.sortAIDocs = this.sortAIDocs.bind(this)
      this.getAIButtonValues = this.getAIButtonValues.bind(this)
      this.docService = docService
      this.translationService = translationService
      this.detailConfig = this.docService.detailConfig
      this.isAIDocument = this.docService.displayAIPage
   }

   getCatalogLink(sortedAIDocs: any[] = []) {
      let catalogLink = ""
      if (sortedAIDocs.length && _.intersection(_.map(sortedAIDocs[0].content_types, (d: any) => d.toLowerCase()), ["journal", "book"]).length) {
         catalogLink = sortedAIDocs[0].link || ""
      }
      return catalogLink
   }

   // returns 0 when it's a print doc and 1 when it's an electronic doc
   // TODO: refactor this to be more intuitive
   isPrint(doc: any) {
      const isElectronicContent = (doc.content_type.match(/^e(journal|book).*/i) !== null)
      if (isElectronicContent || !doc.is_print) { return 1 } else { return 0 }
   }

   sortAIDocs(origDoc: any, aiDocs: any) {
      const sortedDocs: any = []
      // HACK: disconnect the peer documents from each document to have the print documents be the 'main' document
      angular.forEach(aiDocs, (aiDoc: any) => {
         let hasMatch = false
         let docs = (aiDoc.peer_documents || [])
         docs.unshift(aiDoc)
         docs = _.sortBy(docs, this.isPrint)
         // exclude docs if main doc AND peer_documents do NOT have a matching issn/isbn
         angular.forEach(docs, function(doc: any) {
            if (hasMatch) { return }
            return hasMatch = ((origDoc.content_type === "Journal Article") &&
                    origDoc.issns.length &&
                    _.difference(origDoc.issns, _.difference(origDoc.issns, doc.issns)).length) ||
                   ((origDoc.content_type === "Book Chapter") &&
                    origDoc.isbns.length &&
                    _.difference(origDoc.isbns, _.difference(origDoc.isbns, doc.isbns)).length)
         })
         if (!hasMatch) { return }
         aiDoc.peer_documents = []
         const printDoc = _.find(docs, (d: any) => this.isPrint(d) === 0)
         if (printDoc) {
            docs = _.without(docs, printDoc)
            printDoc.peer_documents = docs
            return sortedDocs.push(printDoc)
         }
      })
      return sortedDocs
   }

   getAIButtonValues(doc: any, sortedAIDocs: any) {
      const buttons = {}
      if (!this.docService.displayAIPage(doc)) { return buttons }

      const actions = {
         ill: {
            text: this.translationService.translations.REQUEST,
            link: this.docService.getIllRequestLink(doc),
            clickTrack: false
         },
         catalog: {
            text: this.translationService.translate("Get %{type}", {type: this.translationService.translate(doc.content_type)}),
            link: this.getCatalogLink(sortedAIDocs),
            clickTrack: true
         }
      }

      const primaryAction = this.detailConfig.aiPrimaryAction
      const secondaryAction = _.chain(actions).omit(primaryAction).keys().first().value()

      // @ts-expect-error TS(2339) FIXME: Property 'primary' does not exist on type '{}'.
      if (this.detailConfig.enablePrimaryButton) { buttons.primary = actions[primaryAction] }
      // @ts-expect-error TS(2339) FIXME: Property 'secondary' does not exist on type '{}'.
      if (this.detailConfig.enableSecondaryButton) { buttons.secondary = actions[secondaryAction] }
      return buttons
   }
}

AIDocumentService.$inject = ['documentService', 'translationService']

angular.module('summonApp.services')
   .service('aiDocumentService', AIDocumentService)
